<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="center-container text-xs-left">
          <h1 class="title is-1">{{ $t("new-schedule") }}</h1>
          <div>
            <div>
              <div
                class="p-field-checkbox schedulecBox"
                v-tooltip="'Check this box to create a blank schedule to build by hand'"
              >
                <Checkbox :binary="true" v-model="isBlank" />
                <label v-html="$t('leave-blank-for-manual-game-creation')"></label>
              </div>
              <div class="p-mt-3">
                <p class="p-my-2 title is-5">
                  <br />
                  {{ $t("choose-division-to-schedule-or") }}
                  <router-link to="/divisions/new?return=/schedules/new">{{ $t("create-new-division") }} </router-link>
                </p>
              </div>
            </div>

            <div class="p-grid p-text-left">
              <div
                v-for="d in $store.getters.currentSeason.divisions"
                :key="d.id"
                class="p-col-12 rounded whiteBg paddedCol p-my-3 cursorpointer"
                style="border: 1px solid rgba(0,0,0,0.3); border-radius: 5px;"
                @click="trySchedule(d)"
              >
                <h2 class="title is-2">
                  <div class="colorBall" v-bind:style="{ background: d.color || '#FFFFFF' }" />
                  {{ d.name }}
                </h2>
                <div>{{ $t("teams-d-teams-length", [d.teams.length]) }}</div>
                <div v-for="t in d.teams" :key="t.id">
                  <div class="colorBall" v-bind:style="{ background: d.color || '#FFFFFF' }" />
                  {{ t.name }}
                </div>
                <div v-if="d.teams.length < 2">
                  <br />
                  <p style="color: darkred; font-weight: bold">
                    {{ $t("not-enough-teams") }}
                  </p>
                  <Button
                    @click.stop="goRouter(`/teams/new?division_id=${d.id}&return=/schedules/new`)"
                    :label="$t('Button.add-team')"
                    class="p-button-text p-button-sm"
                  />
                </div>
              </div>
            </div>
            <div v-if="division.id && !timeslots.length">
              <h2 class="title p-mt-5 p-mb-3">
                {{ $t("you-must-create-a-timeslots-before-scheduling") }}
              </h2>
              <Button :label="$t('create-timeslots')" @click="goRouter('/timeslots')" class="p-button p-button-lg" />
            </div>
            <div v-else-if="division.id">
              <p>{{ $t("timeslots-length-timeslots-length", [timeslots.length]) }}</p>
              <div v-if="firstTimeslot" class="my-5">
                <p>{{ $t("first-timeslot-fullmoment-firsttimeslot-start", [fullMoment(firstTimeslot.start)]) }}</p>
                <p>{{ $t("last-timeslot-fullmoment-lasttimeslot-start", [fullMoment(lastTimeslot.start)]) }}</p>
                <p>{{ $t("weeks-in-schedule-with-num", [weeksInSchedule]) }}</p>
                <p>{{ $t("days-in-schedule", [daysInSchedule]) }}</p>
                <!-- <p>Teams: {{ division.teams.length }}</p> -->
                <p>{{ $t("total-timeslots", [timeslots.length]) }}</p>
                <p>
                  {{ $t("this-divisions-timeslots", [divisionTimeslots.length]) }}
                </p>
                <p>
                  {{ $t("neutral-timeslots", [neutralTimeslots.length]) }}
                </p>
                <p>{{ $t("practice-timeslots-practice", [practiceTimeslots.length]) }}</p>
                <p>
                  <strong>{{ $t("needed-timeslots") }}</strong>
                  {{ neededTimeslots }}
                </p>
                <p>
                  <strong>{{ $t("available-timeslots") }}</strong>
                  {{ availableTimeslots }}
                </p>
                <p class="title is-3 has-text-danger" v-if="lackingTimeslots">
                  {{ $t("not-enough-timeslots") }}
                </p>
              </div>
              <div>
                <InputText :placeholder="$t('schedule-name')" autofocus class="fs15" v-model="configuration.title" />
              </div>
              <form @submit.prevent="create" autocomplete="off">
                <!-- <div class="mt-3">
                <b-radio v-model="configuration.style" native-value="round"
                  >Round Robin</b-radio
                >
                <b-radio v-model="configuration.style" native-value="single"
                  >Single Elimination</b-radio
                >
                <b-radio v-model="configuration.style" native-value="double"
                  >Double Elimination</b-radio
                >
              </div> -->
                <div class="my-3" v-if="isRoundRobin">
                  <div class="my-3">
                    <b-numberinput v-model="configuration.input"></b-numberinput>
                  </div>
                  <b-radio v-model="configuration.argument" native-value="rounds">{{ $t("rounds") }}</b-radio>
                  <b-radio v-model="configuration.argument" native-value="week">{{
                    $t("games-per-team-per-week")
                  }}</b-radio>
                  <b-radio v-model="configuration.argument" native-value="season">{{
                    $t("games-per-team-per-season")
                  }}</b-radio>
                </div>
                <div class="columns mt-5">
                  <div class="column">
                    <b-field :label="$t('minimum-rest-between-games-minutes')">
                      <b-numberinput step="15" v-model="configuration.min_minutes_rest"></b-numberinput>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field :label="$t('min-days-between-games')">
                      <b-numberinput v-model="configuration.next_game_offset"></b-numberinput>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field :label="$t('max-games-per-day')">
                      <b-numberinput v-model="configuration.max_games_day"></b-numberinput>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field :label="$t('max-games-per-week')">
                      <b-numberinput v-model="configuration.max_games_week"></b-numberinput>
                    </b-field>
                  </div>
                </div>
                <button type="submit" class="button">{{ $t("start-schedule") }}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      isBlank: false,
      division: {},
      timeslots: [],
      configuration: {
        title: "",
        division_id: null,
        style: "round",
        input: 2,
        argument: "rounds",
        min_minutes_rest: 0,
        max_games_day: 0,
        max_games_week: 0,
        next_game_offset: 0,
        use_weekend_method: 0,
        use_single_division_timeslots: false,
        use_practice_timeslots: false,
        use_unassigned_timeslots: false,
        balance_early_late: false,
        balance_days: false,
        balance_venues: false,
        schedule_start: null,
        schedule_end: null,
        use_coach_conflict_method: false,
        use_player_conflict_method: false,
        venue_balance_method: 0,
        venue_balance_tolerance: 0,
      },
    };
  },
  computed: {
    firstTimeslot() {
      if (this.timeslots) {
        return this.timeslots[0];
      }
    },
    lastTimeslot() {
      if (this.timeslots) {
        return this.timeslots[this.timeslots.length - 1];
      }
    },
    weeksInSchedule() {
      console.log(this.firstTimeslot);
      return this.$moment(this.lastTimeslot.start).diff(this.$moment(this.firstTimeslot.start), "week");
    },
    daysInSchedule() {
      return this.$moment(this.lastTimeslot.start).diff(this.$moment(this.firstTimeslot.start), "day");
    },
    teamCount() {
      console.log("TeamCount", this.division);
      if (this.division && this.division.teams) {
        return this.division.teams.length;
      }
      return 2;
    },
    isRoundRobin() {
      return this.configuration.style == "round";
    },
    isSingleElimination() {
      return this.configuration.style == "single";
    },
    isDoubleElimination() {
      return this.configuration.style == "double";
    },
    filteredTimeslots() {
      var division = [];
      var practice = [];
      var neutral = [];
      this.timeslots.forEach(t => {
        if (t.is_practice) {
          practice.push(t);
        }
        if (!t.divisions.length) {
          neutral.push(t);
        } else if (t.divisions.indexOf(this.division.id) > -1) {
          division.push(t);
        }
      });
      return {
        division: division,
        practice: practice,
        neutral: neutral,
      };
    },
    divisionTimeslots() {
      return this.filteredTimeslots.division;
    },
    neutralTimeslots() {
      return this.filteredTimeslots.neutral;
    },
    practiceTimeslots() {
      return this.filteredTimeslots.practice;
    },
    availableTimeslots() {
      return this.timeslots ? this.divisionTimeslots.length + this.neutralTimeslots.length : 0;
    },
    gamesPerRound() {
      console.log(this.teamCount);
      console.log("GPR", this.teamCount * ((this.teamCount - 1) / 2));
      return this.teamCount * ((this.teamCount - 1) / 2);
    },
    neededTimeslots() {
      if (this.isRoundRobin) {
        if (this.configuration.argument == "rounds") {
          return this.configuration.input * this.gamesPerRound;
        } else if (this.configuration.argument == "week") {
          return this.configuration.input * this.weeksInSchedule;
        } else if (this.configuration.argument == "season") {
          return this.configuration.input * this.teamCount;
        } else if (this.configuration.argument == "total") {
          return this.configuration.input;
        }
      } else if (this.isSingleElimination) {
        return this.gamesPerRound;
      } else if (this.isDoubleElimination) {
        return this.gamesPerRound * 2;
      }
    },
    lackingTimeslots() {
      return this.neededTimeslots > this.availableTimeslots;
    },
  },
  methods: {
    trySchedule(division) {
      console.log(division);
      if (division.teams.length < 2) {
        this.makeToast("info", this.$t("Toast.add-at-least-2-teams-to-a-division"));
        return;
      }
      if (this.isBlank) {
        api
          .createBlankSchedule(division.id)
          .then(response => {
            console.log("Created Blank Schedule", response);
            this.goRouter("/schedules/" + response.data.schedule.id);
          })
          .catch(e => {
            console.log(e);
          });
        return;
      }
      this.goRouter(`/calendar?sd=${division.id}`);
    },
    fullMoment(d) {
      return this.$moment(d).format("LLLL");
    },
    create() {
      console.log("Create schedule");
      this.configuration.division_id = this.division.id;
      if (this.configuration.argument == "week") {
        this.configuration.max_games_week = this.configuration.input;
      }
      api
        .createSchedule(this.configuration)
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("Toast.created-schedule"));
          this.goRouter(`/schedules/` + response.data.id);
          this.refreshLeagueInformation();
        })
        .catch(e => {
          console.log(e);
        });
    },
    getTimeslots() {
      api
        .getSeasonTimeslots(this.$store.getters.currentSeason.id)
        .then(response => {
          console.log("Timeslots", response);
          this.timeslots = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchData() {
      api.getDivision(this.$store.getters.currentSeason.id, this.division.id).then(response => {
        this.division = response.data;
        this.isLoading = false;
        this.getTimeslots();
      });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.params.division_id) {
        this.division.id = this.$route.params.division_id;
        this.$store.getters.currentSeason.divisions.forEach(d => {
          console.log(d);
          if (d.id == this.division.id) {
            this.division = d;
          }
        });
        this.getTimeslots();
      } else {
        this.choosingDivision = true;
      }
    }, 750);
  },
};
</script>

<style lang="scss">
.schedulecBox {
  width: 350px;
  margin: 0 auto;
  // .p-checkbox .p-checkbox-box {
  //     height: 0.8em !important;
  //     width: 0.8em !important;
  // }
  // .p-checkbox {
  //   height: 0.8em;
  //   width: 0.8em;
  // }
}
</style>
